<template>
    <div class="AddressForm">
        <FormInput
            v-model="$v.address.$model"
            lazy
            label="Address"
            :errors="$v.address.$error ? [
                !$v.address.required && 'Address is required',
            ] : null"
            :disabled="disabled"
            :required="required"
        />
        <Row>
            <Column :md="5">
                <FormInput
                    v-model="$v.city.$model"
                    :lazy="lazy"
                    label="City"
                    :errors="$v.city.$error ? [
                        !$v.city.required && 'City is required',
                    ] : null"
                    :disabled="disabled"
                    :required="required"
                />
            </Column>
            <Column :md="3">
                <FormSelectState
                    v-model="$v.state.$model"
                    :lazy="lazy"
                    :errors="$v.state.$error ? [
                        !$v.state.required && 'Required',
                    ] : null"
                    :disabled="disabled"
                    :required="required"
                />
            </Column>
            <Column :md="4">
                <FormInput
                    v-model="$v.zip.$model"
                    :lazy="lazy"
                    label="Zip"
                    :errors="$v.zip.$error ? [
                        !$v.zip.required && 'Zip is required',
                    ] : null"
                    :disabled="disabled"
                    :required="required"
                />
            </Column>
        </Row>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
    name: 'AddressForm',

    props: {
        lazy: { type: Boolean, default: false },
        required: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
    },

    syncProps: [
        'address',
        'city',
        'state',
        'zip',
    ],

    validations() {
        return {
            address: this.required ? { required } : {},
            city: this.required ? { required } : {},
            state: this.required ? { required } : {},
            zip: this.required ? { required } : {},
        };
    },

    methods: {
        validate() {
            this.$v.$touch();
            return !this.$v.$invalid;
        },
    },
}
</script>
